<template>
<div>
    <h2><i class="fa fa-fw fa-lg fa-bank"></i> Bankverbindung</h2>
    <p></p>
    <div class="v-form-partial">
        <div class="v-form">
            <fieldset>
                <section>
                    <label class="label">Bankname</label>
                    <label class="input">
                        <input v-model="bankAccount.bank_name"
                            v-on:keyup.enter="requestModelChange"
                            :class="{ 'text-input-error': hasError('bank_name') }"
                            :disabled="updating"
                            type="text"
                            placeholder="Bankname">
                    </label>
                    <p v-if="hasError('bank_name')" class="text-danger">{{ getError('bank_name') }}</p>
                </section>

                <div class="row">
                    <section class="col col-8">
                        <label class="label">IBAN</label>
                        <label class="input">
                            <input v-model="bankAccount.iban"
                                v-on:keyup.enter="requestModelChange"
                                :class="{ 'text-input-error': hasError('iban') }"
                                :disabled="updating"
                                type="text"
                                placeholder="IBAN">
                        </label>
                        <p v-if="hasError('iban')" class="text-danger">{{ getError('iban') }}</p>
                    </section>
                    <section class="col col-4">
                        <label class="label">BIC</label>
                        <label class="input">
                            <input v-model="bankAccount.bic"
                                v-on:keyup.enter="requestModelChange"
                                :class="{ 'text-input-error': hasError('bic') }"
                                :disabled="updating"
                                type="text"
                                placeholder="BIC">
                        </label>
                        <p v-if="hasError('bic')" class="text-danger">{{ getError('bic') }}</p>
                    </section>
                </div>
            </fieldset>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors.js';
import ModelActionsMixin from '@/mixins/ModelActions.js';

export default {
    props: ['parentResourceId', 'parentResourcePath', 'componentParentView', 'updating'],

    mixins: [FormErrorsMixin, ModelActionsMixin],

    data() {
        return {
            validatedInputs: [
                'bank_name', 'iban', 'bic',
            ],
            errors: [],
            parentView: this.componentParentView,
            modelData: 'bankAccount',
            bankAccount: {
                id: null,
                bank_name: null,
                iban: null,
                bic: null,
            }
        }
    },

    mounted() {
        this.initializeBankAccount();
    },

    methods: {
        initializeBankAccount() {
            this.resetErrors();

            if (!this.parentResourceId) {
                return;
            }

            this.resetModel();
            this.getBankAccount();
        },

        getBankAccount(successCallback) {
            let endpoint = this.$partnerEndpoint(this.parentResourcePath + 'bank-account');

            Api().get(endpoint)
                .then((response) => {
                    this.bankAccount = response.data.data;

                    if (typeof successCallback == 'function') {
                        successCallback();
                    } else {
                        this.emitModelLoadedEvent();
                    }
                })
                .catch((error) => {
                    this.resetModel();
                    this.emitModelLoadedEvent(false);
                });
        },

        storeModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint(this.parentResourcePath + 'bank-account');

            Api().post(endpoint, this.bankAccount)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.storeErrors(error.response.data.errors);
                    this.emitModelUpdatedEvent(false);
                });
        },

        updateModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('bank-accounts/' + this.bankAccount.id);

            Api().put(endpoint, this.bankAccount)
                .then((response) => {
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.storeErrors(error.response.data.errors);
                    this.emitModelUpdatedEvent(false);
                });
        },

        deleteModel() {
            this.resetErrors();
            let endpoint = this.$partnerEndpoint('bank-accounts/' + this.bankAccount.id);

            Api().delete(endpoint)
                .then((response) => {
                    this.contactPerson.id = null;
                    this.emitModelUpdatedEvent();
                })
                .catch((error) => {
                    this.emitModelUpdatedEvent(false);
                });
        },
    },

    watch: {
        parentResourcePath(parsentResourcePath) {
            this.initializeBankAccount();
        },
    }
}
</script>
